/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Password_HintInputs */



/**
* | output |
* | --- |
* | "Your password must be at least 8 characters." |
*
* @param {Auth_Verify_Password_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_password_hint = /** @type {((inputs?: Auth_Verify_Password_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Password_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre mot de passe doit contenir au moins 8 caractères.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su contraseña debe tener al menos 8 caracteres.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sua senha deve ter no mínimo 8 caracteres.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La tua password deve contenere almeno 8 caratteri.")
	return /** @type {LocalizedString} */ ("Your password must be at least 8 characters.")
});